// src/utils/seo.js — per-page <head> management for the React SPA
// Usage: import { setPageMeta } from '../utils/seo'; then call setPageMeta({...}) in a useEffect.

const BASE_URL = 'https://aquav-cloud.de';
const DEFAULT_IMAGE = `${BASE_URL}/avs-logo.png`;

/**
 * Updates document.title, meta description, canonical, and Open Graph tags
 * for the current route.
 *
 * @param {{ title: string, description: string, path?: string, noindex?: boolean }} opts
 */
export function setPageMeta({ title, description, path = '/', noindex = false }) {
  // Title
  document.title = title;

  // Helper: find-or-create a <meta> element
  const setMeta = (selector, attr, value) => {
    let el = document.querySelector(selector);
    if (!el) {
      el = document.createElement('meta');
      const [attrName, attrValue] = attr.split('=');
      el.setAttribute(attrName, attrValue.replace(/"/g, ''));
      document.head.appendChild(el);
    }
    el.setAttribute('content', value);
  };

  const setLink = (rel, href) => {
    let el = document.querySelector(`link[rel="${rel}"]`);
    if (!el) {
      el = document.createElement('link');
      el.setAttribute('rel', rel);
      document.head.appendChild(el);
    }
    el.setAttribute('href', href);
  };

  const canonicalUrl = `${BASE_URL}${path}`;

  setMeta('meta[name="description"]',          'name="description"',    description);
  setMeta('meta[name="robots"]',               'name="robots"',         noindex ? 'noindex, nofollow' : 'index, follow');
  setLink('canonical',                                                   canonicalUrl);
  setMeta('meta[property="og:title"]',         'property="og:title"',   title);
  setMeta('meta[property="og:description"]',   'property="og:description"', description);
  setMeta('meta[property="og:url"]',           'property="og:url"',     canonicalUrl);
  setMeta('meta[property="og:image"]',         'property="og:image"',   DEFAULT_IMAGE);
  setMeta('meta[name="twitter:title"]',        'name="twitter:title"',  title);
  setMeta('meta[name="twitter:description"]',  'name="twitter:description"', description);
}
